"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapStateToProps = exports["default"] = exports.TourDetails = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactRedux = require("react-redux");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _nicbaseTranslation = require("nicbase-translation");

var _tourDetailsModule = _interopRequireDefault(require("./tour-details.module.scss"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var mapStateToProps = function mapStateToProps(state) {
  return {
    linkedPortals: state.informationLists.linkedPortals
  };
};

exports.mapStateToProps = mapStateToProps;

var TourDetails = function TourDetails(_ref) {
  var linkedPortals = _ref.linkedPortals,
      tour = _ref.tour;
  var name = tour.name,
      tourBegin = tour.tourBegin,
      tourEnd = tour.tourEnd,
      owningPortalId = tour.owningPortalId;
  var owner = linkedPortals[owningPortalId] || {};
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: _tourDetailsModule["default"].tourDetails
  }, /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: "requestForData.tourId"
  }, function (label) {
    return /*#__PURE__*/_react["default"].createElement("span", {
      className: _tourDetailsModule["default"].label
    }, label);
  }), /*#__PURE__*/_react["default"].createElement("span", {
    className: _tourDetailsModule["default"].value
  }, name), /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: "requestForData.owner"
  }, function (label) {
    return /*#__PURE__*/_react["default"].createElement("span", {
      className: _tourDetailsModule["default"].label
    }, label);
  }), /*#__PURE__*/_react["default"].createElement("span", {
    className: _tourDetailsModule["default"].value
  }, owner.name), /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: "requestForData.tourBegin"
  }, function (label) {
    return /*#__PURE__*/_react["default"].createElement("span", {
      className: _tourDetailsModule["default"].label
    }, label);
  }), /*#__PURE__*/_react["default"].createElement("span", {
    className: _tourDetailsModule["default"].value
  }, tourBegin.timed && /*#__PURE__*/_react["default"].createElement("span", null, /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedDate, {
    value: tourBegin.timed,
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit"
  })), tourBegin.poi), /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: "requestForData.tourEnd"
  }, function (label) {
    return /*#__PURE__*/_react["default"].createElement("span", {
      className: _tourDetailsModule["default"].label
    }, label);
  }), /*#__PURE__*/_react["default"].createElement("span", {
    className: _tourDetailsModule["default"].value
  }, tourEnd.timed && /*#__PURE__*/_react["default"].createElement("span", null, /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedDate, {
    value: tourEnd.timed,
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit"
  })), tourEnd.poi));
};

exports.TourDetails = TourDetails;
TourDetails.propTypes = {
  tour: _propTypes["default"].shape({
    id: _propTypes["default"].string.isRequired,
    name: _propTypes["default"].string,
    tourBegin: _propTypes["default"].shape({
      timed: _propTypes["default"].string,
      poi: _propTypes["default"].string
    }),
    tourEnd: _propTypes["default"].shape({
      timed: _propTypes["default"].string,
      poi: _propTypes["default"].string
    }),
    owningPortalId: _propTypes["default"].number
  }),
  linkedPortals: _propTypes["default"].shape({})
};
TourDetails.defaultProps = {
  tour: {
    tourBegin: {},
    tourEnd: {}
  },
  linkedPortals: {}
};

var _default = (0, _nicbaseTranslation.injectIntl)((0, _reactRedux.connect)(mapStateToProps)(TourDetails));

exports["default"] = _default;